<template>
  <res-dialog :title="titleMessage"
              :showDialog="showDialog"
              :smallTitleIcon="true"
              :cancelButtonOnly="true"
              :cancelButtonTextColor="'primary--text'"
              :cancelButtonColor="'primary'"
              :cancelButtonText="'OK'"
              :cancelButtonWidth="'80'"
              :iconColor="'white'"
              iconTitle="mdi-calendar-blank-multiple"
              :showTitleIcon="true"
              :titleClass="'resBlue darken-1 white--text'"
              @cancel="close">
    <v-container>
      <v-card-text>  <v-list three-line>
              <template v-for="(item, index) in history">
                <v-list-item :key="item.budgetIterationNoteId">
                  <v-list-item-content>
                    <v-list-item-title>{{item.createdBy}}</v-list-item-title>
                    <v-list-item-subtitle>{{localizeDate(item.created)}}</v-list-item-subtitle>
                    <v-list-item-subtitle><span class="text--primary"><span v-if="item.workflowRuleId != null">Step: {{item.workflowGroupStep}} Group: {{item.workflowGroupName}} <br />Status: </span>{{item.note}}</span></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index < (history.length - 1)" :key="index"></v-divider>
              </template>
            </v-list>  
      </v-card-text>
    </v-container>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  import budgetService from '@/services/budget';
  import Localizable from '@/mixins/Localizable.js';

  import { mapActions } from 'vuex';

  export default {
    components: {
      ResDialog
    },
    mixins: [
      Localizable
    ],
    data: function () {
      return {
        setHeight: '30',
        history: [],
      };
    },
    props: {
      height: {
        type: Number
      },
      maxWidth: {
        type: Number
      },
      showDialog: {
        type: Boolean
      },
      width: {
        type: Number
      },
      budgetIterationDescription: {
          type: String
      },
      budgetIterationId: {
        type: String
      }
    },
    methods: {
      ...mapActions(['changeLoading']),
      close() {
        this.$emit('close', true)
      },
    },
    computed: {
      calculateHeight() {
        return "height:" + this.setHeight + "px";
      },
      titleMessage() {
        if (this.budgetIterationDescription !== undefined && this.budgetIterationDescription !== null) {
          return 'Status History for ' + this.budgetIterationDescription;
        } else {
          return 'Status History';
        }
      },
    },
    async mounted() {
      this.changeLoading(true);
      let response = await budgetService.getStatusHistory(this.budgetIterationId);
      if (response && response.data) {
        this.history = response.data;
      } else {
        this.history = [];
      }
      this.changeLoading(false);
    }
  }
</script>
